<template>
  <div class="index">
    <div class="nav text-title">
      支持 Ta 的梦想
    </div>

    <ul class="list">
      <li v-for="(goods, index) in goodsList" :key="index" @click="onSelectShop(goods, index)">
        <div class="l-li" :class="index === goodsNum ? 'active': ''">
          <div class="img">
            <img v-lazy="goods.cover">
          </div>
          <div class="title">
            {{ goods.meal }}
          </div>
          <div class="info">
            {{ goods.name }}
          </div>
        </div>
        <div class="btn" @click.stop="onDetails(goods)">
          查看详情
        </div>
      </li>
    </ul>

    <div class="nav">
      填写您的收货信息
    </div>

    <div class="from">
      <van-field v-model="items.name" placeholder="请输入收货人姓名" :maxlength="20" />
      <van-field v-model="items.phone" placeholder="请输入收货人手机号码"/>
      <div class="address-text" :class="{'active': items.addressText }" @click="onAddress">
        {{ items.addressText }}
      </div>
      <van-field class="textarea"
        v-model="items.adder"
        type="textarea"
        placeholder="请输入详细地址"
      />
      <van-field class="textarea"
        v-model="items.content"
        type="textarea"
        placeholder="请输入您的留言"
      />
    </div>

    <div class="btn-box">
      <van-button @click="onSubData" class="btn" type="info" color="#ff4400">支持 Ta: <i>￥{{ goodsObj.price }}</i></van-button>
    </div>

    <van-popup v-model="popupShow" style="width:80%; height:80%;">
      <div v-html="goodsImgObj.graphics"></div>
    </van-popup>

    <!--  地址  -->
    <van-popup v-model="show" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="options"
        @close="show = false"
        @finish="onFinish"
        @change="onChange"
        :field-names="{text: 'name' }"
      />
    </van-popup>
  </div>
</template>

<script>
import axios from '@/config/axios'

export default {
  name: 'index',
  data() {
    return {
      title: 'index',
      popupShow: false,
      goodsList: [],
      items: {
        uid: 0,
        content:
          '朋友就是要互相支持，今天我帮你，明天你帮我！拼人品的时候到了！旅行，力挺你的壮举！',
        adder: '',
        id: 0,
        name: '',
        phone: '',
        province: '',
        area: '',
        city: '',
        town: '',
        addressText: ''
      },
      addressArray: ['province', 'area', 'city', 'town'],
      goodsImgObj: {},
      goodsNum: '',
      goodsObj: {
        price: 0
      },
      cascaderValue: false,
      show: false,
      options: []
    }
  },
  created() {
    this.init()
  },
  mounted() {
  },
  methods: {
    init() {
      axios.get('goods', '', {}, true)
        .then(res => {
          if(res.code === -1) {
            window.localStorage.removeItem('code')
            window.localStorage.removeItem('token')
            window.localStorage.removeItem('user')
            this.$router.push({
              name: 'index'
            })
            return
          }
          this.goodsList = res.data
        })
        .catch(rej => {
          console.log(rej)
        })
    },
    onSelectShop(item, index) {
      this.goodsObj = item
      this.goodsNum = index
    },
    onDetails(item) {
      this.goodsImgObj = item
      this.popupShow = true
    },
    onAddress () {
      axios.get('caddress', { parent_id: 0 }, '', true)
      .then(res => {
        res.data.forEach(item => {
          item.children = []
        })
        this.options = res.data
      })
      .catch(() => {})
      this.show = true
    },
    onChange ({ value, selectedOptions, tabIndex }) {
      this.items[this.addressArray[tabIndex]] = value
      axios.get('caddress', { parent_id: value }, '', true)
          .then(res => {
            if (res.data.length < 1) {
              this.show = false
              selectedOptions[tabIndex].children = null
              console.log('change', res.data)
              this.items.addressText = ''
              selectedOptions.forEach(item => {
                this.items.addressText += item.name
              })
            } else {
              res.data.forEach(item => {
                item.children = []
              })
              selectedOptions[tabIndex].children = res.data
            }
          })
          .catch(() => {})
    },
    onFinish ({ selectedOptions }) {
      console.log('infinish:', selectedOptions)
    },
    onSubData () {
      if (!this.goodsObj.id) {
        this.$toast('请选择您支持的商品')
        return
      }
      this.items.id = this.goodsObj.id

      // let nameTest = /^[\u2E80-\u9FFF]+$/
      if (!this.items.name) {
        this.$toast('请往下滑，填写收货信息')
        return
      }

      let test = /^[1][3-9][0-9]{9}$/
      if (!test.test(this.items.phone)) {
        this.$toast('请填写正确的手机号码')
        return
      }

      if (!this.items.addressText) {
        this.$toast('请选择您的地址')
        return
      }

      if (!this.items.adder) {
        this.$toast('请填写您的详细地址')
        return
      }

      if (!this.items.content) {
        this.$toast('请填写您的支持宣言')
        return
      }
      let _this = this
      _this.items.uid = window.localStorage.getItem('id')
      axios.post('cpayment', _this.items)
          .then(res => {
            if (res.code !== 1) {
              this.$toast(res.message)
              return
            }
            window.location.href = res.url
          }).catch(() => {})
    }
  }
}
</script>
<style>
.van-cascader__title{
	font-size:.2rem;
}
.van-cascader__option{
	font-size:.2rem;
}
</style>
<style scoped lang="scss">
.index {
  padding-bottom: 100px;

  .nav {
    text-align: center;
    line-height: 80px;
    font-size: 28px;
    background: #ff4400;
    color: #ffffff;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;
  }
  .text-title {
    box-shadow: 0 0 15px 0 rgba(0,0,0,.2);
  }

  .list {
    display: flex;
    padding: 20px 20px;
    width: 100%;
    box-sizing: border-box;
    flex-wrap: wrap;

    li {
      box-shadow: 0 0 15px 0 rgba(0, 0, 0, .2);
      width: calc(50% - 10px);
      background: #ffffff;
      border-radius: 15px;
      overflow: hidden;
      padding: 20px;
      position: relative;
      box-sizing: border-box;
      margin-bottom: 20px;
      &:nth-child(2n) {
        margin-left: 20px;
      }
      .l-li {
        position: relative;
        &:before {
          content: none;
          position: absolute;
          background: url("data:image/png;base64,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") rgba(0, 0, 0, 0.7) no-repeat 50%;
          background-size: 2rem auto;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 5;
        }
        &.active {
          &:before {
            content: ' ';
          }
        }
      }
      .img {
        width: 100%;
        height: auto;
        margin-bottom: .2rem;
	max-height: 1.5rem;
	overflow: hidden;

        img {
          width: 100%;
          height: auto;
          vertical-align: top;
        }
      }
      .title {
        font-size: 30px;
        line-height: 48px;
        padding: 0 .15rem;
      }

      .info {
        font-size: 26px;
        line-height: 36px;
        min-height: .72rem;
        padding: 0 .15rem;
        font-weight: normal;
        width: 100%;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .btn {
        margin: .3rem .15rem 0;
        font-size: 36px;
        background: #ff4400;
        color: #ffffff;
        text-align: center;
        line-height: 70px;
        border-radius: 0.08rem;
      }
    }
  }
  .van-cell{
    font-size: .24rem;
    line-height: .24rem;
  }
  .address-text {
    padding: 10Px 16Px;
    background: #ffffff;
    font-size: .24rem;
    line-height: .24rem;
    color: #323233;
    position: relative;
    &:after {
      position: absolute;
      box-sizing: border-box;
      content: '';
      pointer-events: none;
      right: 16Px;
      bottom: 0;
      left: 16Px;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(.5);
      transform: scaleY(.5);
    }
    &:before {
      content: '请选择您的收货地址';
      color: #999999;
    }
    &.active {
      &:before {
        content: none;
      }
    }
  }
  .btn-box {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: 0;
    z-index: 999;
    i {
      font-size: 32px;
    }

    .btn {
      height: 56px;
      width: 100%;
      border-radius: 0;
      font-size: 30px;
    }
  }
}
.textarea{
	/deep/ {
	.van-field__control{
		font-size:.3rem;
		line-height:.4rem;
	}
	}
}
</style>

<style>
.van-dialog__message{
	font-size:.3rem!important;
	line-height:.4rem!important;
}
.van-dialog{
	font-size:.3rem!important;
}
</style>
